import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import IconPlay from '@/components/UI/svg/blade/treaser/Play';
import EFVideoModal from '@/components/UI/EFVideoModal';
import { youtubeMap } from '@/constants/delta2max';
import Emarsys from '@/components/SignUpForm/Emarsys';

const Icon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="0.5" y="0.5" width="19" height="19" stroke="#30BF00" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.59512 11.9621L6.07317 9.60421L5 10.6147L8.59512 14L16 7.02737L14.9268 6L8.59512 11.9621Z"
                fill="#30BF00"
            />
        </svg>
    );
};

export default function Z1({ stage }: any) {
    const { useLang, useRouter, useState, gtm, Link } = useGlobal();
    const { t } = useLang('delta2max.teaser');
    const { locale } = useRouter();
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);
    const [step, setStep] = useState(1); // 1 订阅 2 订阅成功

    const playerVideo = () => {
        setShowEFVideoModal(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow DELTA 2 Max | UX video',
            position: stage === 'detail' ? 'Product Detail_1' : 'Product_1',
        });
    };

    const successCallBack = (email: string) => {
        setStep(2);
        // setTimeout(() => {
        //     setStep(1);
        // }, 3000);
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('sec1_sign'),
                status: 'success',
                tag: 'None',
                product_name: 'EcoFlow DELTA 2 Max',
            });
            const url = `https://media.ecoflow.com/u/register.php?CID=1045840001&f=1215&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=${email.trim()}&inp_4433=1&inp_9104=1`;
            window.open(url, '_blank');
        } catch (e) {
            console.error(e);
        }
    };

    const errorCallback = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_submit',
            button_name: t('sec1_sign'),
            status: 'fail',
            tag: 'None',
            product_name: 'EcoFlow DELTA 2 Max',
        });
    };

    return (
        <div className={`d2x-Z1 ${css.d2xZ1}`}>
            <div className={`sec1 ${stage === 'detail' ? 'sec1-detail' : ''}`}>
                <div className="main-box">
                    <div className="img-box">
                        <NextImage src={require('@publicLocal/delta2max/teaser/pc/eu/au_1.jpg')} alt={t('sec1_title')} aria-label={t('sec1_title')} />
                    </div>
                    <div className="text-box">
                        <p className="title">{t('sec1_title')}</p>
                        <div className="subtitle-box">
                            <div className="subtitle-text">{t('sec1_subtitle')}</div>
                        </div>
                        {stage === 'teaser' && (
                            <Emarsys
                                source={'Web new product sub'}
                                submitText={t('sec1_sign')}
                                placeholder={t('sec1_placeholder')}
                                successCallback={successCallBack}
                                errorCallback={errorCallback}
                            />
                        )}
                        {stage != 'teaser' && (
                            <Link href="https://au.ecoflow.com/products/delta-2-max-portable-power-station" className="shop-now">
                                SHOP NOW
                            </Link>
                        )}
                        {step === 2 && (
                            <div className="success-tips">
                                <Icon />
                                <p className="tips">
                                    Thanks for signing up!
                                    <br />
                                    Please check your email to receive a 5% early bird coupon code.
                                </p>
                            </div>
                        )}
                    </div>
                    <div className="watch-box" hidden onClick={playerVideo}>
                        <div className="watch-text">{t('sec1_watch')}</div>
                        <div className="watch-icon">
                            <IconPlay fillBg="#fff" fillTrangle="#000" />
                        </div>
                    </div>
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={youtubeMap[locale] || youtubeMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
